export const Style = ({ colors = [] }) => (
  <g id="Estilo2_2_">
    <linearGradient
      id="SVGID_199_"
      gradientUnits="userSpaceOnUse"
      x1="75.7"
      y1="384.0525"
      x2="75.7"
      y2="401.6302"
      gradientTransform="matrix(1 0 0 -1 0 480)"
    >
      <stop offset="0" style={{ stopColor: colors[0] }} />
      <stop offset="1" style={{ stopColor: colors[1] }} />
    </linearGradient>
    <path
      style={{ display: 'inline', fill: 'url(#SVGID_199_)' }}
      d="M88.2,75.5c-3.1-0.2-5.6-2.9-9.3-2.8c-0.8,0-1.6,0.3-2.3,0.4 c-0.2,0.1-0.3,0.1-0.5,0.1c0.4,0.9,1.1,1.9,1.8,1.9c1.3-0.1,2.4-0.3,3.2-0.3c3.1-0.3,6.2,1.9,6.7,2.2s-2.4,7.1-3.3,7.1 c-0.9,0-3.1-2.4-4-1.8c-0.8,0.6-2.4,2.4-4.5,2.4l0,0c0,0-0.1,0-0.1,0s-0.1,0-0.1,0l0,0c0,0-0.1,0-0.1,0v0c0,0,0,0-0.1,0s0,0-0.1,0 v0c0,0-0.1,0-0.1,0l0,0c0,0-0.1,0-0.1,0s-0.1,0-0.1,0l0,0c-2.1-0.1-3.7-1.9-4.5-2.4c-0.8-0.6-3.1,1.9-4,1.8 c-0.9,0-3.7-6.8-3.3-7.1c0.4-0.3,3.6-2.5,6.7-2.2c0.8,0.1,1.9,0.2,3.1,0.3c0.8,0.1,1.4-0.9,1.9-1.9c-0.2,0-0.3-0.1-0.5-0.1 c-0.9-0.1-1.6-0.4-2.3-0.4c-3.7-0.1-6.2,2.6-9.3,2.8c-3.3,0.2-7.3-8.2-8.2-10.5c0.9,7.8,2,15.7,2.4,16.7c0.3,0.6,1.2,2.4,2.5,3.7 c0.2,0.2,0.3,0.3,0.5,0.5c0.9,0.8,3.5,1.9,5.1,2.5c0.4,0.2,0.8,0.3,1.2,0.5l0,0c0.3,0.2,0.6,0.3,0.9,0.5c1.6,0.9,5,2.7,8,2.7 c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0,0c3.1,0,6.4-1.7,8-2.7c0.3-0.2,0.6-0.3,0.9-0.5l0,0c0.4-0.2,0.8-0.4,1.2-0.5 c1.6-0.6,4.2-1.7,5.1-2.5c0.2-0.2,0.3-0.3,0.5-0.5c1.2-1.3,2.2-3.1,2.4-3.7c0.4-1,1.5-8.9,2.4-16.7C95.5,67.3,91.6,75.8,88.2,75.5 z"
    />
  </g>
)
